import * as React from 'react';
import { makeStyles, Grid, Typography, Paper } from '@material-ui/core';
import { IframeComponent2 } from './IframeComponent2';
import { stores } from '../store';
import { observer } from 'mobx-react-lite';
import RecentlyOpenedJobs from '../components/Ask/RecentlyOpenedJobs';
import { PageTitle } from 'components/Design';

const useStyles = makeStyles(theme => ({
	frameContainer: {
		margin: '10px 25px',
		width: '100%',
		overflowX: 'auto',
	},
	frameBox: {
		width: '100%',
		'@media (max-width:768px)': {
			width: '768px',
		},
	},
	paper: {
		display: 'flex',
		height: '100%',
		flexDirection: 'column',
		boxShadow: 'none !important',
		marginTop: '4px',
		marginLeft: '20px',
		'@media (max-width:768px)': {
			marginLeft: '0',
		},
	},
	jobsDisplay: {
		height: '850px',
		width: '512px',
		[theme.breakpoints.down('md')]: {
			width: '312px',
		},
	},
	esmeWithJobs: {
		width: 'calc(100% - 522px)',
		[theme.breakpoints.down('md')]: {
			width: 'calc(100% - 332px)',
		},
	},
	esmeWindow: {
		width: '100%',
	},
	textMargin: {
		textAlign: 'center',
	},
}));

const DynamicForm: React.FunctionComponent = observer(() => {
	const user = React.useContext(stores.context.user);
	const classes = useStyles();

	const esmeUrl = process.env.REACT_APP_ESME_URL;
	const site = user.esmesite.find(({ Id }: any) => Id === user?.currentSiteId);

	return (
		<div className={classes.frameContainer}>
			{site?.EsmeClientId ? (
				<Grid container spacing={1} key={site.EsmeClientId} className={classes.frameBox}>
					{user.CafmId === 1 && (
						<Grid item className={classes.jobsDisplay}>
							<RecentlyOpenedJobs />
						</Grid>
					)}
					<Grid className={user.CafmId === 1 ? classes.esmeWithJobs : classes.esmeWindow}>
						<Paper className={classes.paper}>
							<Grid container>
								<PageTitle>Job Request Form</PageTitle>
							</Grid>
							<Grid container style={{ height: '100%' }}>
								<Grid item xs={12}>
									<IframeComponent2
										iframeSrc={esmeUrl + 'dialogueForm?subChannel=dy02&dform=x'}
										height="100%"
										width="100%"
										token={user.token}
										clientId={site.EsmeClientId}
									/>
								</Grid>
							</Grid>
						</Paper>
					</Grid>
				</Grid>
			) : site && site?.EsmeClientId === null ? (
				<>
					<div className={classes.textMargin}>
						<Typography variant="subtitle2">Chatbot is not available for this site.</Typography>
					</div>
				</>
			) : (
				<>{/* Loading Site Data */}</>
			)}
		</div>
	);
});

export default DynamicForm;
